import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const JobProfileWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #e4e5e7;
  padding: 105px 0 0 60px;

  ${mediaMaxWidth.tablet`
    padding: 49px 0 0 0;
  `}
`;

export const JobProfileInner = styled.div`
  width: 960px;
  display: flex;
  flex-direction: row;

  ${mediaMaxWidth.smallDesktop`
    flex-direction: column;
    align-items: center;
  `}
`;
